import { formatNumberThousand } from "app/shared/util/format-currency";
import moment from "moment";
import { ITEMLISTSTATEMENTBACKUP } from "app/shared/services/services-model.type";

export const createDynamicHTMLString = (data: ITEMLISTSTATEMENTBACKUP[]) => {
  let tbody: string = "";
  let total_debit: number = 0;
  let total_amount: number = 0;
  let str_total_debit: string;
  let str_total_amount: string;
  // Create number formatter.
  data.map((item: any) => {
    const tr: string = `<tr> 
    <td>${moment(item.TRANSACTIONDATE, "YYYY-MM-DD hh:mm:ss").format("DD/MM/YYYY")}</td>
    <td>${item.SEQUENCENO}</td>
    <td>${item.CONTENT}</td>
    <td>${item.DEBITAMOUNT !== "0" ? formatNumberThousand(item.DEBITAMOUNT) : ""}</td>
    <td>${item.CREDITAMOUNT !== "0" ? formatNumberThousand(item.CREDITAMOUNT) : ""}</td>
    <td>${item.ENDINGBALANCE !== "0" ? formatNumberThousand(item.ENDINGBALANCE) : ""}</td>
    </tr>`;
    tbody = tbody + tr;
    total_debit = total_debit + parseInt(item.DEBITAMOUNT, 10);
    total_amount = total_amount + parseInt(item.CREDITAMOUNT, 10);
  });

  const first: ITEMLISTSTATEMENTBACKUP = data[0];
  const currentBalance = formatNumberThousand(first.CURRENTBALANCE);
  const beforeAmount = formatNumberThousand(first.DUDAUNGAY);
  const fromDate = moment(first.FROMDATE, "YYYY-MM-DD hh:mm:ss").format("DD/MM/YYYY");
  const toDate = moment(first.TODATE, "YYYY-MM-DD hh:mm:ss").format("DD/MM/YYYY");
  const currencyCode = first.CURRENCYCODE || "VND";
  const accountNo = first.ACCOUNTNO || "";
  const accountName = first.ACCOUNTNAME || "";

  str_total_debit = formatNumberThousand(total_debit);
  str_total_amount = formatNumberThousand(total_amount);

  const htmlString = `<!DOCTYPE html>
<html translate="no" lang="vi">
<head>
    <meta charset="UTF-8">
    <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta name="googlebot" content="notranslate" />
    <link rel="preconnect" href="https://fonts.googleapis.com">
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
    <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&display=swap" rel="stylesheet">
    <style>
        @page WordSection1 {
            size: A4;
            margin: 54.0pt 36.0pt 36.0pt 36.0pt;
        }

        footer {
          position: fixed;
          bottom: 0;
          right: 0;
        }

        table { page-break-inside:auto; word-break: break-all; word-wrap:break-word; }
        tr    { page-break-inside:avoid; page-break-after:auto; }
        td    { page-break-inside:avoid; page-break-after:auto; }
        thead { display:table-header-group }
        tfoot { display:table-footer-group }
        tbody { page-break-before: avoid; }


        div.WordSection1 {
            page: WordSection1;
        }


        body {
            font-family: "Montserrat", serif;
            font-size: small;
        }

        .title {
            text-align: center;
        }

        .left-title {
            float: left;
            min-width: 50%;
            padding-left: 16px;
            font-family: "Montserrat", serif;
            font-weight: 600;
        }

        .subtilte {
            font-family: "Montserrat", serif;
            font-size: small;
            padding: 2px 0px;
        }

        .bold-text {
            font-family: "Montserrat", serif;
            font-weight: bold;
        }

        .center-title {
            font-family: "Montserrat", serif;
            /* line-height: 1.2rem; */
            font-weight: 700;
            font-size: 18px;
            padding: 4px 0px;
            text-align: center;
        }

        table {
            font-family: "Montserrat", serif;
            border-collapse: collapse;
            table-layout: fixed; width: 100%
        }

        th {
            border: 1px solid #000;
            text-align: left;
            padding: 8px;
            text-align: center;
            word-wrap: break-word;
            font-size: 13px;
        }

        td[colspan="2"] {
          text-align: center;
        }

        td {
            border: 1px solid #000;
            padding: 8px;
            word-wrap: break-word;
            border-style: dashed solid;
            border-color: black;
            font-size: 12px;
        }
    </style>
</head>

<body style='word-wrap:break-word'>
    <div class=WordSection1>
        <div style="display:block;width: 100%;float: left;">
            <div class="left-title" style="text-align: center;">Ngân hàng TMCP Đại Chúng Việt Nam (PVcomBank)<br><br></div>
            <div class="left-title" style="text-align: center;">Đơn vị : . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . .<br></div>
            <div class="left-title" style="text-align: center;">-------------------</div>
        </div>

        <div style="display: inline">
            <div style="display: inline;">
                <div style="text-align: center">
                    <div class="center-title">SỔ PHỤ TÀI KHOẢN</div>
                    <div class="subtilte">
                        <span>
                            Từ ngày:
                            <span id="fromdate">${fromDate}</span>
                        </span>
                        <span style="padding: 0px 8px">-</span>
                        <span>
                            Đến ngày:
                            <span id="todate">${toDate}</span>
                        </span>
                    </div>
                    <div style="padding-bottom: 8px;">Loại tiền tệ: <span id="typeCurrentcy">${currencyCode}</span></div>
                </div>

                <div style="position: absolute;top: 40px;right: 0px;">
                    <img src=${require("@assets/images/logo/bitmap_bg_white.png")}
                        style="width: 160px;height: 70px" />
                </div>
            </div>
        </div>
        <div>
            <span>
                Tài khoản số:
            </span>
            <span id="accountNumber">
            ${accountNo}
            </span>
            <span style="padding: 0px 4px">
                -
            </span>
            <span id="accountName">${accountName}</span>
        </div>
        <table style="margin-top: 12px;">
            <thead>
                <tr>
                    <th style="text-align: center;">Ngày giao dịch</th>
                    <th style="max-width: 100px;">Bút toán</th>
                    <th>Nội dung phát sinh</th>
                    <th>Phát sinh nợ</th>
                    <th>Phát sinh có</th>
                    <th>Số dư</th>
                </tr>
                <tr style="border-style: dashed solid solid;border: 1px solid #000;">
                  <td class="bold-text" colspan="2">Số dư đầu</td>
                  <td class="bold-text"></td>
                  <td class="bold-text"></td>
                  <td class="bold-text">${beforeAmount}</td>
                <td></td>
            </tr>
            </thead>
            <tbody>
                ${tbody}
            </tbody>
            <tfoot>
                <tr>
                    <td class="bold-text" colspan="2">Doanh số trong kì</td>
                    <td></td>
                    <td class="bold-text">${str_total_debit}</td>
                    <td class="bold-text">${str_total_amount}</td>
                    <td class="bold-text"></td>
                </tr>

                <tr style="border-style: dashed solid solid;border: 1px solid #000;">
                    <td class="bold-text" colspan="2">Số dư cuối</td>
                    <td></td>
                    <td class="bold-text"></td>
                    <td class="bold-text" class="bold-text">${currentBalance}</td>
                    <td class="bold-text"></td>
                </tr>
            </tfoot>
        </table>

        <!-- Giao dịch viên -->
        <div style="display: flex;margin: 48px 0px 120px;page-break-after:auto">
            <div style="flex: 1;text-align: center;" class="bold-text">
                Giao dịch viên
            </div>
            <div style="flex: 1;text-align: center;" class="bold-text">
                Kiểm soát viên
            </div>
        </div>
        <p style="font-size: 10px;">
            Sổ phụ này được in trên hệ thống máy tính, đã được kiểm soát và không cần đóng dấu
        </p>
    </div>
</body>
</html>`;
  return htmlString;
};
